<tcc-simplePanel [size]="panalSize" [buttons]="['close']" (buttonClick)="close()">

    <div panel-header *ngIf="state === 'ready'">
        <div *ngIf="addOrEdit === 'add'">Add</div>
        <div *ngIf="addOrEdit === 'edit'">Edit {{currentAccountSplit?.name}}</div>
    </div>

    <div panel-body *ngIf="state === 'ready'">
        <div class="container">
            <div class="row">
                <div class="col-12" style="text-align: center;">
                    <h4>Account Split</h4>
                </div>
            </div>

            <form [formGroup]="accountSplitFormGroup" (ngSubmit)="onSubmit()">

                <input type="text" 
                       formControlName="id" 
                       #id 
                       name="id" 
                       hidden>

                <label for="name">Name: </label>
                <input type="text" 
                       formControlName="name" 
                       name="name" 
                       [ngClass]="{changed: isChanged('name')}"
                       #name>
                <br />
                <br />

                <label for="type">Type: </label>
                <select name="type"
                        formControlName="type"
                        [ngClass]="{changed: isChanged('type')}">
                    <option value="Expense">Expense</option>
                    <option value="Revenue">Revenue</option>                    
                </select>
                <br />
                <br />

                
                <label for="orgCode">Org Code: </label>
                <input type="text" 
                       formControlName="orgCode"
                       [ngClass]="{changed: isChanged('orgCode')}"
                       name="orgCode" 
                       #orgCode>


                <label for="account"> Account: </label>
                <input type="text" 
                       formControlName="account" 
                       [ngClass]="{changed: isChanged('account')}"
                       name="account"
                       #account>

                <label for="percentage">Percentage: </label>
                <input type="number" 
                       formControlName="percentage" 
                       #percentage 
                       [ngClass]="{changed: isChanged('percentage')}"
                       name="percentage">


                <div style="margin-top: 10px;">
                    <button type="submit" [disabled]="!accountSplitFormGroup.valid || 
                                                      !accountSplitFormGroup.dirty">Save</button>
                </div>
            </form>
        </div>
    </div>

</tcc-simplePanel>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>